/**
 * 🟦 V14.4 — i18n setup (react-i18next).
 *
 * Alcance V14.4 inicial: páginas públicas (Marketplace, Login, Header, Footer)
 * + botones críticos del Moderation Panel y del Inbox de Lyon.
 *
 * Reglas:
 *  - Idiomas soportados: es (default) + en.
 *  - Auto-detect del navegador con fallback a 'es'.
 *  - Las traducciones viven en `./locales/{es,en}.json` (JSON plano por
 *    namespace 'common' para empezar simple).
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { common: es },
      en: { common: en },
    },
    fallbackLng: 'es',
    defaultNS: 'common',
    interpolation: { escapeValue: false }, // React ya escapa.
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'damyxia_lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
